import {
  MARK_VALID_FIELDS_DATA_REQUEST,
  MARK_VALID_FIELDS_DATA_SUCCESS,
  MARK_VALID_FIELDS_DATA_FAIL,
} from '../constants/markValidFieldsConstants';

export const markValidFieldsReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case MARK_VALID_FIELDS_DATA_REQUEST:
      return { loading: true, formData: [] };
    case MARK_VALID_FIELDS_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case MARK_VALID_FIELDS_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
